import React, { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import LoginPage from '../pages/Login/Login';
import { Theme } from '../Types/types';

interface AccessControlProps {
  setTheme: (theme: Theme) => void;
  children: ReactNode;
}

const AccessControl: FC<AccessControlProps> = ({ setTheme, children }) => {
  const location = useLocation();
  const isLoginActive = location.pathname === '/login';
  return <>{isLoginActive ? <LoginPage setTheme={setTheme} /> : children}</>;
};

export default AccessControl;
